import { useAuth } from '@clerk/clerk-react'
import { useMutation } from '@tanstack/react-query'

import { createEcwCredentialIntakeLink } from './api'

export function useEcwCredentialIntakeMutation() {
  const { getToken } = useAuth()

  return useMutation({
    mutationFn: async () => {
      const token = await getToken()
      if (!token) throw new Error('No authentication token available')
      return createEcwCredentialIntakeLink(token)
    },
  })
}
